<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div windeGridHeader>
    <div windeGridCell>{{ 'engineersManagement.login' | translate }}</div>
    <div [maxWidth]="'15%'" windeGridCell>{{ 'engineersManagement.firstName' | translate }}</div>
    <div [maxWidth]="'15%'" windeGridCell>{{ 'engineersManagement.lastName' | translate }}</div>
    <div [maxWidth]="'10%'" windeGridCell>{{ 'engineersManagement.profiles' | translate }}</div>
    <div *ngIf="isShowEULACol$ | async" [maxWidth]="'7%'" windeGridCell>{{ 'engineersManagement.eulaAccept' | translate }}</div>
    <div *windeHasAnyAuthority="userAuthorities.ALL_SIKLU" [maxWidth]="'20%'" windeGridCell>
        {{ 'engineersManagement.lastLogin' | translate }}
    </div>
    <div [maxWidth]="'5%'" windeGridActionsCell></div>
</div>

<div windeGridStripedRows>
    @for (user of users$ | async; track user.id) {
        <div windeGridRow [ngClass]="{ highlight_user: user.isHighlighted }">
            <div windeGridCell>
                <span [showDelay]="2000" [tooltipText]="user.login.value" position="top" suiTooltip>
                    {{ user.login.value }}
                </span>
            </div>
            <div windeGridCell [maxWidth]="'15%'">
                <span [showDelay]="2000" [tooltipText]="user.firstName.value" position="top" suiTooltip>
                    {{ user.firstName.value }}
                </span>
            </div>
            <div windeGridCell [maxWidth]="'15%'">
                <span [showDelay]="2000" [tooltipText]="user.lastName.value" position="top" suiTooltip>
                    {{ user.lastName.value }}
                </span>
            </div>
            <div windeGridCell [maxWidth]="'10%'">
                <winde-user-role-badge [userAuthority]="user.authorities[0].value"></winde-user-role-badge>
            </div>
            <div *ngIf="isShowEULACol$ | async" [maxWidth]="'7%'" windeGridActionsCell>
                <div *ngIf="user.authorities[0].value === userAuthorities.COMPANY_ADMIN">
                    <span *ngIf="(currentEULA$ | async) && (currentEULA$ | async).versionDate; else noEULA">
                        <sui-svg-icon
                                [icon]="user.eulaAcceptanceRequired ? 'cross' : 'check'"
                                [ngClass]="user.eulaAcceptanceRequired ? 'eula-red' : 'eula-green'"
                        />
                    </span>
                    <ng-template #noEULA>
                        <span>No EULA</span>
                    </ng-template>
                </div>
            </div>
            <div windeGridCell *windeHasAnyAuthority="userAuthorities.ALL_SIKLU" [maxWidth]="'20%'">
                <span *ngIf="user.lastAuthDate">{{ user.lastAuthDate | date: 'MMM d, y, h:mm:ss a' }}</span>
            </div>
            <div *ngIf="showEditBtn$ | async" [maxWidth]="'5%'" windeGridActionsCell>
                <winde-ctx-sensitive-help
                        [routerLink]="['', { outlets: { popup: [action.EDIT, 'user', user.id.value] } }]"
                        placement="left"
                        queryParamsHandling="preserve"
                        tooltipTextPath="user.grid.rowBtn.edit"
                >
                    <sui-svg-icon icon="pencil" windeOrange/>
                </winde-ctx-sensitive-help>
                <winde-ctx-sensitive-help
                        *ngIf="(currentAccount$ | async).id.value !== user.id.value"
                        [routerLink]="[
                        '',
                        { outlets: { popup: [action.DELETE, (baseUrl$ | async) === 'sales' ? 'sale' : 'user', user.id.value] } }
                    ]"
                        placement="left"
                        queryParamsHandling="preserve"
                        tooltipTextPath="user.grid.rowBtn.remove"
                >
                    <sui-svg-icon icon="cross" windeRed/>
                </winde-ctx-sensitive-help>
            </div>
        </div>
    } @empty {
        <div windeGridEmpty>
            <strong>{{ 'customer.home.' + ((customerFilter$ | async) ? 'matchesNotFound' : 'usersNotFound') | translate }}</strong>
        </div>
    }
</div>

<sui-pagination
        (pageChange)="loadPage($event)"
        [collectionSize]="totalItems$ | async"
        [page]="page$ | async"
        windeGridPagination
></sui-pagination>
